import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { togglePlanSection_D } from "../../actions/showDisplayModalAction";
import { CalendlyPop, isOldUser } from "../../utils";

const UpgradeBtn = ({ cls = '' }) => {
    const dispatch = useDispatch();
    const userData = useSelector(state => state.authenticated.userData);
    const checkUser = !isOldUser(userData?.user?.createdAt) || ['1', '58'].includes(userData?.UserPlan?.planId)
    const btnName = checkUser ? 'Talk to Sales' : userData?.user?.updateName;
    // const btnName = userData?.user?.updateName;
    const btnStatus = userData?.user?.updateStatus || checkUser;
    // const btnStatus = userData?.user?.updateStatus;
    const [show, setShow] = useState(false);

    const hidePop = () => setShow(false);
    const upgradePlan = () => {
        if (btnStatus == 1) setShow(true);
        else dispatch(togglePlanSection_D(true))
    };
    return (btnName &&
        <>
            <Button variant="primary" className={cls} onClick={upgradePlan}>{cls ? <small>{btnName}</small> : btnName}</Button>
            {show && <CalendlyPop show={show} hidePop={hidePop} url={['1', '58'].includes(`https://calendly.com/taggbox/${['1', '58'].includes(userData?.UserPlan?.planId) ? "demo" : "csm"}?embed_domain=app.socialwalls.com&embed_type=PopupText`)} />}
        </>
    );
}

export default UpgradeBtn